import { sanitizeSsoErrorMessageForLogin } from "@repo/shared";
import { Navigate, useSearchParams } from "react-router";
import { readSsoLoginQuery } from "@/lib/post-login-redirect";

/**
 * SSO error landing (QL-348). better-auth appends `?error=<code>` to the SSO
 * error URL without checking for an existing query, so the URL it gets is this
 * bare path. The code is handed to the login page as `?ssoError=`, together with
 * the login query remembered before the SSO redirect (`?redirect=`, MCP OAuth
 * params), so a retry still completes the flow the login was part of.
 *
 * `ssoRef`/`ssoKind` (QL-637) are forwarded as-is. The IdP's `error_description`
 * is forwarded as `ssoMessage`, already reduced with
 * `sanitizeSsoErrorMessageForLogin` (plain text, links and domains replaced,
 * capped). The login page sanitises it again, since anyone can craft that URL,
 * and labels it as the sign-in provider's message (PO decision 2026-10-20).
 */
export default function SsoErrorPage() {
  const [searchParams] = useSearchParams();
  const params = readSsoLoginQuery();
  params.set("ssoError", searchParams.get("error") || "unknown");
  for (const key of ["ssoRef", "ssoKind"]) {
    const value = searchParams.get(key);
    if (value) params.set(key, value);
  }
  const message = sanitizeSsoErrorMessageForLogin(searchParams.get("error_description"));
  if (message) params.set("ssoMessage", message);
  return <Navigate replace to={`/login?${params.toString()}`} />;
}
